module.exports = __webpack_public_path__ + "img/bring-solutions-dark.746eacd5.svg";